var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['app-notice', 'app-notice--' + _vm.variant]},[_c('i',{class:_vm.resolvedIcon}),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }